//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Exports data table to html.
 */
(function () {
    'use strict';

    angular
        .module('container.core')
        .factory('excelExportService', excelExportService)
        ;


    function excelExportService() {
        var service = {
            generateExcel: generateExcel
        };

        return service;

        function generateExcel(tableData, tableModel, excelName) {
            let tableModelEdited = editTableModel(tableModel);
            let tableHtml = generateTableHTML(tableData, tableModelEdited);
            generateExcelBlob(tableHtml, excelName);
        }

        function generateExcelBlob(tableHtml, worksheetName) {            
            worksheetName = worksheetName ? worksheetName : "exportData" + new Date().toDateString();
            var blob = new Blob(["\ufeff", tableHtml]);
            if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
                window.navigator.msSaveOrOpenBlob(blob, 'exportData' + new Date().toDateString() + '.xls');
            }
            else {
                var a = window.document.createElement("a");
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" });
                a.download = worksheetName + ".xls";
                document.body.appendChild(a);
                a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
                document.body.removeChild(a);
            }
        }

        /*
        * function to generate the table HTML
        * @param tableData - the array containing the tableData
        * @param tableModel - the array containing the tableModel
        */
        function generateTableHTML(tableData, tableModel) {
            let table = document.createElement('table');

            let tr = document.createElement('tr'),
                td1 = document.createElement('td'),
                th = document.createElement('th'),
                clnRow, clnData;
         
            clnRow = tr.cloneNode(true);
            tableModel.columns.forEach(function(column) 
            {   
                clnData = th.cloneNode(true);
                clnData.innerText = column.key;
                clnRow.appendChild(clnData);                
            })
            table.appendChild(clnRow);
            
            tableData.forEach(function (row) {
                clnRow = tr.cloneNode(true);
                tableModel.columns.forEach(function (column) {
                    clnData = td1.cloneNode(true);
                    if (row[column.key] || typeof row[column.key] === 'number') {
                        if (typeof row[column.key] === 'number' || row[column.key][0].match("^[a-zA-Z0-9]*$")) {
                            clnData.innerText = row[column.key];
                        } else {
                            clnData.innerText = "'" + row[column.key];
                        }
                    } else {
                        clnData.innerText = "";
                    }  
                    clnRow.appendChild(clnData);
                    table.appendChild(clnRow);

                })
            })
            return table.outerHTML;
        }

        /*
        * function to edit the HTML table
        * @param tableData - the array containing the tableData
        * @param tableModel - the array containing the tableModel
        */
        function editTableModel(tableModel) {
            tableModel.columns.forEach(function (column, index, array) {
                if (column.key === "expand" || column.title === "Action" || column.key === "select" || column.key === "_mt_overlay__" || column.key === "__mt_rowOverlay__" || column.key === "__mt_action__") {
                    array.splice(index, 1);
                }
            })
            return tableModel;
        }

    }
})();
